export function parseParamToString(param: string | undefined): string {
  if (param === undefined) {
    return '';
  } else {
    return String(param);
  }
}
